import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import './FilterDrawer.css';

// Right-side sheet for building/editing one saved filter (SavedFilterTabs'
// pencil/"+ New") — same shell HelpSheet.js uses, and modal for the same
// reason Help is: this is a focused, staged edit of a filter's definition,
// not live browsing. Unlike an earlier version of this component, it does
// NOT live-apply to the underlying list as you type — Cancel simply closes
// with nothing having happened, Save both persists and applies. Live,
// ad hoc narrowing has its own separate always-visible "quick row" outside
// this drawer entirely.
// width overrides the sheet's default width for a reading-heavy list (e.g.
// the CRM Dashboard's Synced Email review).
// Being modal, it takes every click outside itself as closing it, so anything
// opened from it (a ReportOverlay) goes among its children. onEscapeKeyDown
// lets that thing keep Escape to itself.
function FilterDrawer({ open, onOpenChange, title, description = 'Build and save a filter combination.', children, footer, width, onEscapeKeyDown }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="filter-drawer-overlay" />
        <Dialog.Content className="filter-drawer-content" style={width ? { width } : undefined} onEscapeKeyDown={onEscapeKeyDown}>
          <Dialog.Title className="filter-drawer-title">{title}</Dialog.Title>
          <Dialog.Description className="filter-drawer-description">
            {description}
          </Dialog.Description>
          <Dialog.Close asChild>
            <button type="button" className="filter-drawer-close" aria-label="Close">
              <X size={16} strokeWidth={2} />
            </button>
          </Dialog.Close>
          <div className="filter-drawer-body">{children}</div>
          {footer && <div className="filter-drawer-footer">{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default FilterDrawer;
